import { render, staticRenderFns } from "./editKeyboxPanel.vue?vue&type=template&id=4be349b6&scoped=true&"
import script from "./editKeyboxPanel.vue?vue&type=script&lang=js&"
export * from "./editKeyboxPanel.vue?vue&type=script&lang=js&"
import style0 from "./editKeyboxPanel.vue?vue&type=style&index=0&id=4be349b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be349b6",
  null
  
)

export default component.exports